import { render, staticRenderFns } from "./NewsTile.vue?vue&type=template&id=61988e2c&scoped=true&"
import script from "./NewsTile.vue?vue&type=script&lang=ts&"
export * from "./NewsTile.vue?vue&type=script&lang=ts&"
import style0 from "./NewsTile.vue?vue&type=style&index=0&id=61988e2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61988e2c",
  null
  
)

export default component.exports